export const createLeadModalId = 'create-lead-modal';
export const updateLeadModalId = 'update-lead-modal';
